import React from "react"
import OurOfficesImg from "../../../images/Our-Offices.svg"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-20 px-6 pb-12">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Our</span> homes
          </h1>
          <h3 className="text-3xl pb-4">
            <b>A second home</b> to feel like if you are at home.
          </h3>
          <p className="pb-8">Buscamos que cada integrante del Team AVALITH se sienta cómodo a la hora de trabajar, fomentando como resultado <b>compromiso y pasión.</b></p>     
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img src={OurOfficesImg} alt="Our" className="mx-auto" width="500" />
        </div>
      </div>
    </section>
  )
}

export default Hero
